export const MINIMUM_PAYMENT_AMOUNT = 100
